<template>
  <div class="groupMessage">
    <div class="itemCard">
      <div v-if="$store.state.isMobile">{{detail.museumName}}</div>
      <div class="baseLine" v-if="$store.state.isMobile"></div>
      <div class="itemTitle" v-if="!$store.state.isMobile">团队信息</div>
      <div class="detailContentWarp">
        <div class="detailContent">
          <span class="title">团队名称</span>
          <span class="name groupName">{{group.orgName}}</span>
        </div>
        <div class="detailContent">
          <span class="title">团队负责人</span>
          <span class="name">{{group.personName || group.peopleName}}</span>
        </div>
        <div class="detailContent" v-if="detail.bookingDate">
          <span class="title">预约日期</span>
          <span class="name">{{detail.bookingDate}}</span>
        </div>
        <div class="detailContent">
          <span class="title">入场时段</span>
          <span class="name">{{detail.time}}</span>
        </div>
        <div class="detailContent">
          <span class="title">联系电话</span>
          <span class="name">{{group.phone}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },

  props: ['detail', 'group'],

  methods: {
    
  },

  created() {
    
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.itemCard{
  padding: 0.3rem;
}
.detailContentWarp{
  text-align: left;
}
.detailContent{
  width: 50%;
  display: inline-block;
  font-size: 0.4rem;
  line-height: 0.4rem;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .title{
    margin-right: 0.3rem;
    font-weight: 500;
  }
  .name{
    color: #666666;
    font-size: 0.35rem;
  }
}
</style>
<style type="text/css" lang="scss">
  .pcItemCard{
    .detailContentWarp{
      background-color: #fff;
      padding: 1%;
      border-radius: 0.1rem;
      text-align: left;
      padding-left: 0.7rem;
    }
    .detailContent{
      width: 45%;
      font-size: 20px;
      line-height: 50px;
      .name{
        font-size: 22px;
      }
    }
  }
</style>





